import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { notification, Form, Icon } from "antd";
import axios from "axios";
import moment from "moment";
import LazyLoad from "react-lazy-load";

import { GlobalContext } from "../../../app/providers/GlobalState.jsx";

import Controlos from "../components/Controlos.jsx";
import ControlosSimples from "../components/ControlosSimples.jsx";
import Oops from "../../../pages/Oops.jsx";

import { iconSessaoPresencial } from "../../../assets/tipoDeConteudos";

class SessaoPresencial extends Component {
    static contextType = GlobalContext;
    state = {
        curso: "",
        modulo: "",
        moduloIndex: 0,
        aulaid: 0,
        aula: "",
        aulaIndex: 0,
        fullscreen: false,
        nome: "",
        objetivos: "",
        dt_inicio: null,
        hora: null,
        local: "",
        current: "",
        updateModulos: false,
        dataHora: "",
        //REDIRECT
        redirect: false,
        redirectLink: "",
        sameUrl: true,
        //NAO DISPONIVEL
        nao_disponivel: false,
        //LOADING
        loading: true
    };

    //CHAMADA ANTES DO RENDER
    UNSAFE_componentWillMount() {
        axios.defaults.timeout = 60 * 10 * 1000;
        this.context.montarNavbar(false);
        var aulaId = localStorage.getItem("codigo_aula");

        this.setState({
            curso: this.props.match.params.curso,
            aulaid: aulaId
        });

        this.CarregarConteudo(aulaId);
    }

    UNSAFE_componentWillReceiveProps(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            var aulaId = localStorage.getItem("codigo_aula");

            this.CarregarConteudo(aulaId);
            this.setState(
                {
                    sameUrl: false
                },
                () =>
                    this.setState({
                        sameUrl: true
                    })
            );
        }
    }

    //CARREGA A AULA
    CarregarConteudo = aulaid => {
        axios({
            method: "get",
            url: "/api/gestao-player/conteudo3",
            params: {
                aulaid: aulaid
            }
        })
            .then(response => {
                this.setState({
                    nome: response.data.nome,
                    objetivos: response.data.objetivos,
                    dt_inicio: response.data.dt_inicio ? moment(response.data.dt_inicio).format("DD/MM/YYYY") : "",
                    hora: response.data.hora,
                    local: response.data.recurso,
                    dataHora: moment(response.data.dataHora).format("DD/MM/YYYY HH:mm"),
                    loading: false
                });
            })
            .catch(error => {
                //if (error.response.data === "SEM_PERMISSAO")
                //    this.setState({
                //        redirect: true,
                //        redirectLink: "/user"
                //    });
                //else
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });

                this.setState({
                    nao_disponivel: true
                });
            });
    };

    render() {
        const {
            curso,
            nome,
            objetivos,
            dt_inicio,
            hora,
            local,
            dataHora,
            //REDIRECT
            redirect,
            redirectLink,
            sameUrl,
            //NAO DISPONIVEL
            nao_disponivel,
            //LOADING
            loading
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return loading ? (
            <div className="loading-data">
                <div className="loading" />
            </div>
        ) : (
            <div className="questionario">
                <div className="player-wrapper">
                    {!nao_disponivel ? (
                        <>
                            <div className="container">
                                <div className="bloco-presencial">
                                    <div className="bloco-info sessao-presencial bloco-player-template">
                                        <div className="bloco-info-tarefa">
                                            <span className="icon-tarefa">
                                                <img src={iconSessaoPresencial} />
                                            </span>
                                            <span className="titulo-tarefa">{nome}</span>
                                        </div>
                                        <p
                                            className="descricao-tarefa"
                                            dangerouslySetInnerHTML={{ __html: objetivos?.replace(/(?:\r\n|\r|\n)/g, "<br>") }}
                                        ></p>
                                        <Form className="form-aula" layout="horizontal" style={{ margin: 0 }}>
                                            <div className="info">
                                                <Form.Item>
                                                    <span className="desc">
                                                        <Icon type="calendar" /> {dt_inicio}
                                                    </span>
                                                </Form.Item>
                                                {hora && (
                                                    <Form.Item>
                                                        <span className="desc">
                                                            <Icon type="clock-circle" /> {hora}
                                                        </span>
                                                    </Form.Item>
                                                )}
                                                <Form.Item>
                                                    <span className="desc">
                                                        <Icon type="home" />{" "}
                                                        <span
                                                            dangerouslySetInnerHTML={{ __html: local.replace(/(?:\r\n|\r|\n)/g, "<br>") }}
                                                        ></span>
                                                    </span>
                                                </Form.Item>
                                            </div>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                            <Controlos
                                backUrl={
                                    localStorage.getItem("player_back_url")
                                        ? localStorage.getItem("player_back_url")
                                        : `/gerir-curso/${curso.replace(/[&/\\#,+()$~%.'":*?!<>{}\s]/g, "-").toLowerCase()}/curso-modulos`
                                }
                                sameUrl={sameUrl}
                                temAnotacoes
                                nome={nome}
                                objetivos={objetivos}
                                icon={iconSessaoPresencial}
                                dataHora={dataHora}
                            />
                        </>
                    ) : (
                        <>
                            <div className="container">
                                <div className="bloco-nao-disponivel">
                                    <div className="bloco-info nao-disponivel">
                                        <Oops tem_texto texto={"Conte�do n�o dispon�vel"} />
                                    </div>
                                </div>
                            </div>
                            <ControlosSimples />
                        </>
                    )}
                </div>
            </div>
        );
    }
}

export default SessaoPresencial;
